/* eslint-disable */
/* eslint-enable */
/* eslint eqeqeq: 0, curly: 2 */

import {
  Typography,
  Banner,
  Button,
  Col,
  Form,
  Divider,
  Modal,
  Row,
  Tabs,
  TabPane,
  Toast,
  List,
  Avatar,
  Space,
  Tooltip,
  Popover,
  Tag,
  SideSheet
} from "@douyinfe/semi-ui";
import {
  ApiClient,
  getLeadStatusOpt,
  Lead,
  LeadAssignLog,
  LeadContactLog,
  LeadStarLog,
  displayLeadStatus,
  ReadOnlyLeadStatus,
  getSalesLeadStatusOpt,
  Loan,
  displayLoanStatus,
  LeadStatus,
  User,
  ApiResp,
  Page,
  ReadOnlyVisitLeadStatus,
  LoanContactLog,
} from "../../api/ApiClient";
import {
  IconHelpCircle,
  IconSave,
  IconUserCardPhone,
  IconRotate,
  IconChevronLeft,
  IconChevronRight,
  IconBell,
  IconLikeHeart,
  IconCopy,
  IconBookmark, IconModalStroked,
} from "@douyinfe/semi-icons";
import React, { useEffect, useState, useRef } from "react";
import "./leadDetail.css";
import { CrudOption } from "../../comp/crud";
import {
  avatarName,
  formatDateTime,
  displayStar,
  StarList,
  formatRelativeTime,
} from "../../utils";
import { FormApi } from "@douyinfe/semi-ui/lib/es/form";
import pubsub from "pubsub-js";
import IndexMortgageLoan from "../mortgageLoan/indexMortgageLoan";

export interface LeadDetailProps {
  viewMode?: boolean;
  visitMode?: boolean;
  findLeadMode?: boolean;
  leadId?: number;
  leadIds?: number[];
  queryParams?: any;
  onOk?: () => void;
  onCancel?: () => void;
  onSentToPool?: () => void;
  newWindow?: boolean;
  leadFrom?: string;
}
const Title = Typography.Title;
const apiClient = ApiClient.getDefault();
const {
  TextArea,
  Section,
  Input,
  DatePicker,
  TimePicker,
  Select,
  Switch,
  InputNumber,
  Checkbox,
  CheckboxGroup,
  RadioGroup,
  Radio,
} = Form;
const starHelp = (
  <p style={{ lineHeight: "2em" }}>
    1星：客户是没有可贷点；人在外地（本人不在本地工作者）
    <br />
    2星：有按揭车、全款车、商业保单、企业或则个体户有纳税
    <br />
    3星：外地按揭房、外地全款房、外地公积金
    <br />
    4星：本地有缴纳公积金
    <br />
    5星：本地按揭房、本地全款房、本地回迁房有证
    <br />
    （客户如果是多个条件，则选择最高星级）
  </p>
);
const callPhoneHelp = (
  <p style={{ lineHeight: "2em" }}>
    1：要使用拨号功能 ，请下载APP，使用自己的账号和密码登录
    <br />
    2：若提示手机端不在线，请先登录手机端，若APP连接服务器失败，请点击手动连接按钮
  </p>
);
const contactLogTemplate = [
  "无需贷款",
  "未接电话",
  "客户挂机",
  "客户关机",
  "空号",
  "拨打的用户正忙  请稍后再拨",
  "停机",
  "提贷挂",
  "通话中",
  "转语音留言",
  "现在忙，稍后联系",
];

/** 字典选项缓存 */
interface DictCache {
  [code: string]: CrudOption[];
}

export function LeadDetail(props: LeadDetailProps) {
  const [leadContactLogs, setLeadContactLogs] = useState(
    [] as LeadContactLog[]
  );
  const [leadAssignLogs, setLeadAssignLogs] = useState([] as LeadAssignLog[]);
  const [leadStarLogs, setLeadStarLogs] = useState([] as LeadStarLog[]);
  const [contactLogSaving, setContactLogSaving] = useState(false);
  const [starSaving, setStarSaving] = useState(false);
  const [visitTimeSaving, setVisitTimeSaving] = useState(false);
  const [leadSaving, setLeadSaving] = useState(false);

  const [showMobile, setShowMobile] = useState(true);

  const [loans, setLoans] = useState([] as Loan[]);
  const [lead, setLead] = useState(undefined as undefined | Lead);
  const [leadId, setLeadId] = useState<number>();
  const [leadIds, setLeadIds] = useState<number[]>();
  const [userInfoForm, setUserInfoForm] = useState<any>();
  const [statusForm, setStatusForm] = useState<any>();
  const [visitForm, setVisitForm] = useState<any>();
  const [logForm, setLogForm] = useState<any>();
  const [loadingAll, setLoadingAll] = useState(false);
  const [showInfo, setShowInfo] = useState(
    apiClient.getPref<boolean>("userInfo")
  );
  const [showTodo, setShowTodo] = useState(false);
  const [todoFormApi, setTodoFormApi] = useState<any>();
  const [savingTodo, setSavingTodo] = useState(false);
  const [poolSaving, setPoolSaving] = useState(false);
  const [starInfoAll, setStarInfoAll] = useState<CrudOption[]>([]);
  const [starInfo, setStarInfo] = useState<CrudOption[]>([]);
  const formRef = useRef(null);
  const [statusInfoAll, setStatusInfoAll] = useState<CrudOption[]>([]);
  const [statusInfo, setStatusInfo] = useState<CrudOption[]>([]);
  let [admin, setAdmin] = useState<User>();
  const [readOnlyLeadStatus, setReadOnlyLeadStatus] = useState([] as any);
  const [viewMode, setViewMode] = useState(false);
  const [savingFav, setSavingFav] = useState(false);
  const [leadFav, setLeadFav] = useState(false);
  const [leadMy, setLeadMy] = useState(false);
  const [visitSignLogText, setVisitSignLogText] = useState("");
  const [actVisitTimeDisabled, setActVisitTimeDisabled] = useState(true);
  const role = localStorage.getItem("role");
  const username = localStorage.getItem("username");
  const city = localStorage.getItem("city");

  const [selectedLeads, setSelectedLeads] = useState([] as any[]);
  const [assignSaving, setAssignSaving] = useState(false);
  const [selectedMembers, setSelectedMembers] = useState([] as any[]);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [assignFormApi, setAssignFormApi] = useState<any>(undefined);
  const [teamMembersTree, setTeamMembersTree] = useState([] as any[]);
  const [loanContactLogs, setLoanContactLogs] = useState(
    [] as LoanContactLog[]
  );

  const [showMortgageLoan, setShowMortgageLoan] = useState(false);
  const [hasAssignPriv, setHasAssignPriv] = useState(false);

  // 字典缓存
  const [dicts, setDicts] = useState<DictCache>({});
  const [helpVisible, setHelpVisible] = useState(false);
  const [activeHelpCategory, setActiveHelpCategory] = useState('');

  const loadDicts = async () => {
    const codes = [
      "gender", "marriage", "city", "loanType", "house", "vehicle",
      "company", "providentFund", "workYears", "income",
    ];
    const cache: DictCache = {};
    for (const code of codes) {
      cache[code] = await apiClient.getDictAsOpts(code);
    }
    setDicts(cache);
  };

  const renderDictRadio = (dictCode: string, field: string, label: string) => {
    const opts = dicts[dictCode];
    if (!opts || opts.length === 0) return null;
    return (
      <Form.RadioGroup key={dictCode} field={field} label={{
                              text: label,
                            }}
        style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
        {opts.map((o) => (
          <Form.Radio key={o.key} value={o.value}>{o.label}</Form.Radio>
        ))}
      </Form.RadioGroup>
    );
  };

  const openHelpPage = () => {
    setHelpVisible(true);
  };

  let getAdmin = async () => {
    try {
      await apiClient.initToken();
      let admin = (await apiClient.getCurrentAdmin()).data;
      setAdmin(admin);
    } catch (e) { }
  };

  const loadLead = async () => {
    if (leadId == undefined) {
      return Promise.resolve(undefined);
    }
    let l = await apiClient.getLead(leadId);
    console.log("leadStatus: " + l.status);
    if (props.visitMode || String(l.status) == "VISITED") {
      console.log("visitMode");
      setReadOnlyLeadStatus(ReadOnlyVisitLeadStatus);
    } else {
      setReadOnlyLeadStatus(ReadOnlyLeadStatus);
    }
    userInfoForm?.setValues(l);
    statusForm?.setValues(l);
    visitForm?.setValues(l);
    logForm?.setValues(l);

    if (props.newWindow) {
      window.document.title = "客户:" + l?.name;
    }
    //加载星级和状态
    let statusOpt = getSalesLeadStatusOpt();
    setStatusInfoAll(statusOpt);

    if (l?.star == 0) {
      setStatusInfo(
        statusOpt.filter((item) => {
          return item.value == "PENDING_CONTACT" || item.value == "UNREACHABLE";
        })
      );

      if (
        String(l.status) != "PENDING_CONTACT" &&
        String(l.status) != "UNREACHABLE"
      ) {
        let newLeadStatus: LeadStatus = "PENDING_CONTACT" as LeadStatus;
        l.status = newLeadStatus;
      }
    } else if (l?.star == 1) {
      setStatusInfo(
        statusOpt.filter((item) => {
          return item.value != "PENDING_CONTACT" && item.value != "UNREACHABLE";
        })
      );

      if (
        String(l.status) == "PENDING_CONTACT" ||
        String(l.status) == "UNREACHABLE"
      ) {
        let newLeadStatus: LeadStatus = "OUT_LEAD" as LeadStatus;
        l.status = newLeadStatus;
      }
    } else {
      setStatusInfo(
        statusOpt.filter((item) => {
          return (
            item.value != "PENDING_CONTACT" &&
            item.value != "UNREACHABLE" &&
            item.value != "OUT_LEAD" &&
            item.value != "NON_COMPLIANCE"
          );
        })
      );
      if (
        String(l.status) == "PENDING_CONTACT" ||
        String(l.status) == "UNREACHABLE" ||
        String(l.status) == "OUT_LEAD"
      ) {
        let newLeadStatus: LeadStatus = "PENDING_VISIT" as LeadStatus;
        l.status = newLeadStatus;
      }
    }

    setLead(l);
    setLeadFav(l.fav);
    setLeadMy(String(l.leadType) == "MY");

    let starArr = StarList.map((s) => {
      return {
        label: displayStar(s),
        value: s,
        key: s + "",
      };
    });
    setStarInfoAll(starArr);
    setStarInfo(starArr);
  };

  const loadLeadIds = async () => {
    if (!props.queryParams) {
      return;
    }

    if (props.leadFrom == "visitSignLog") {
      let apiResp: ApiResp<Page<any>> = await apiClient.request(
        "/leadVisitSignLog",
        "GET",
        props.queryParams
      );
      let leadIdsLocal = apiResp.data.records.map((v) => v.leadId);
      return leadIdsLocal;
    } else {
      let apiResp: ApiResp<Page<any>> = await apiClient.request(
        "/leads",
        "GET",
        props.queryParams
      );
      let leadIdsLocal = apiResp.data.records.map((v) => v.id);
      return leadIdsLocal;
    }
  };

  const loadLeadContactLogs = () => {
    return apiClient
      .getAllLeadContactLogs(leadId!)
      .then((logs) => setLeadContactLogs(logs));
  };

  const loadLoanContactLogs = () => {
    return apiClient
      .getAllLoanContactLogs(leadId!)
      .then((logs) => setLoanContactLogs(logs));
  };

  const loadLeadAssignLogs = () => {
    apiClient
      .getAllLeadAssignLogs(leadId!)
      .then((logs) => setLeadAssignLogs(logs));
  };

  const loadLeadStarLogs = () => {
    apiClient.getAllLeadStarLogs(leadId!).then((logs) => setLeadStarLogs(logs));
  };

  const loadLeadVisitAssignLogs = () => {
    apiClient.getAllLeadVisitAssignLogs(leadId!).then((logs) => {
      let logText = "";
      logs.forEach((log) => {
        if (log.confirmAt) {
          logText = logText + log.saleName + "  " + log.createdAt + "\r\n";
        } else {
          logText = logText + log.saleName + "  " + log.createdAt + "(未确认)\r\n";
        }

      });
      setVisitSignLogText(logText);
    });
  };

  const loanLeadLoans = () => {
    apiClient.getAllLeadLoans(leadId!).then((l) => setLoans(l));
  };

  const refreshParentLead = () => {
    localStorage.setItem("new-refresh", "true");
    localStorage.setItem("my-refresh", "true");
    localStorage.setItem("fav-refresh", "true");
    localStorage.setItem("team-refresh", "true");
    localStorage.setItem("pool-refresh", "true");
    pubsub.publish("refreshMenuCount", "");
  };

  const handleSendToPool = async () => {
    Modal.confirm({
      title: "是否确认要送回公共池?",
      content: "",
      onOk: async () => {
        setPoolSaving(true);
        try {
          await apiClient.request("/leads/pool", "POST", undefined, {
            leadIds: [leadId!],
          });
          Toast.info("已送回公共池");
          props.onSentToPool && props.onSentToPool();
          refreshParentLead();
          setPoolSaving(false);
        } catch (e) {
          setPoolSaving(false);
        }
      },
    });
  };

  const nextLeadId = () => {
    if (!leadIds) {
      return undefined;
    }
    const i = leadIds.indexOf(leadId!);
    return leadIds[i + 1];
  };

  const preLeadId = () => {
    if (!leadIds) {
      return undefined;
    }
    const i = leadIds.indexOf(leadId!);
    return leadIds[i - 1];
  };

  const handleNextClick = async () => {
    if (!props.queryParams) {
      return;
    }
    let nextId = nextLeadId();
    if (!nextId) {
      if (props.leadFrom == 'report') {
        Toast.warning("该页已经没有下一条数据了，请切换到下一页后再打开客户详情");
        return;
      } else {
        props.queryParams.page = parseInt(props.queryParams.page) + 1;
        let leadIdsLocal = await loadLeadIds();
        setLeadIds(leadIdsLocal);
        if (leadIdsLocal && leadIdsLocal.length > 0) {
          nextId = leadIdsLocal[0];
        } else {
          Toast.warning("没有下一条");
          return;
        }
      }
    }
    setLeadId(nextId);
  };

  const handlePrevClick = async () => {
    if (!props.queryParams) {
      return;
    }
    let preId = preLeadId();
    if (!preId) {
      if (props.leadFrom == 'report') {
        Toast.warning("该页已经没有上一条数据了，请切换到上一页后再打开客户详情");
        return;
      } else {
        if (props.queryParams.page == 1) {
          Toast.warning("没有上一条");
          return;
        }
        props.queryParams.page = parseInt(props.queryParams.page) - 1;
        let leadIdsLocal = await loadLeadIds();
        setLeadIds(leadIdsLocal);
        if (leadIdsLocal && leadIdsLocal.length > 0) {
          preId = leadIdsLocal[leadIdsLocal.length - 1];
        } else {
          Toast.warning("没有上一条");
          return;
        }
      }

    }
    setLeadId(preId);
  };

  const loadAll = async () => {
    if (!leadId) {
      console.log("没有leadId");
      return;
    }
    setLoadingAll(true);
    try {
      await loadLead();
      loadLeadContactLogs();
      loadLoanContactLogs();
      loadLeadAssignLogs();
      loadLeadStarLogs();
      loadLeadVisitAssignLogs();
      loanLeadLoans();
      setLoadingAll(false);
    } catch (e) {
      setLoadingAll(false);
    }
  };

  useEffect(() => {
    const body = document.body;
    let themeMode = localStorage.getItem("theme-mode");
    if (themeMode == "light") {
      body.removeAttribute("theme-mode");
    } else if (themeMode == "dark") {
      body.setAttribute("theme-mode", "dark");
    } else {
      body.removeAttribute("theme-mode");
    }

    setLeadId(props.leadId);

    if (role == "source") {
      setShowMobile(false);
    }
    if (props.leadFrom == 'report' && props.leadIds && props.leadIds.length >= 0) {
      setLeadIds(props.leadIds);
    } else {
      loadLeadIds().then((data) => setLeadIds(data));
    }

    if (role == "root" || role == "monitor") {
      setActVisitTimeDisabled(false);
    }

    let isManager = role == "quzhang" || role == "sale_manager" || role == "op_manager" || role == "monitor" || role == "root";
    setHasAssignPriv(isManager);

    let currUsername;
    if (role == "op_manager" || role == "monitor") {
      currUsername = "root";
    } else {
      currUsername = username;
    }
    apiClient
      .getTeamMemberTreeAsOptsOfAny(currUsername)
      .then((opts) => setTeamMembersTree(opts));

    loadDicts();
  }, [props.leadId]);

  useEffect(() => {
    if (leadId) {
      loadAll();
    } else {
      setLead(undefined);
    }
  }, [leadId]);

  const handleToggleUserInfo = () => {
    const result = !showInfo;
    setShowInfo(result);
    apiClient.putPref("userInfo", result);
  };
  const handleTodoSubmit = async () => {
    await todoFormApi!.validate();
    const values = todoFormApi!.getValues();
    const content = values["content"];
    const dueDate = formatDateTime(values["dueDate"]);
    setSavingTodo(true);
    try {
      await apiClient.request("/todos", "POST", undefined, {
        leadId: leadId,
        content: content,
        dueDate: dueDate,
      });
      setSavingTodo(false);
      todoFormApi?.reset();
      setShowTodo(false);
      Toast.info("提醒信息已保存");
    } catch (e) {
      setSavingTodo(false);
    }
  };

  const handleAssignButtonClick = () => {
    setSelectedLeads([lead]);
    setShowAssignModal(true);
    let strIds = localStorage.getItem("assignToIds");
    if (strIds) {
      apiClient
        .request("/users/removeLeaveUserId", "GET", {
          ids: JSON.parse(strIds),
        })
        .then((resp: ApiResp<any>) => {
          setSelectedMembers(resp.data);
        });
    }
  };

  const handleAssignClick = async () => {
    setAssignSaving(true);
    try {
      await assignFormApi!.validate();
      await apiClient.request(
        "/leads/assign",
        "POST",
        undefined,
        assignFormApi!.getValues()
      );
      let assignToIds = assignFormApi!.getValue("assignToIds");
      localStorage.setItem("assignToIds", JSON.stringify(assignToIds));

      setSelectedLeads([]);
      localStorage.setItem("my-refresh", "true");
      localStorage.setItem("new-refresh", "true");
      localStorage.setItem("all-refresh", "true");
      setAssignSaving(false);
      setShowAssignModal(false);

      pubsub.publish("refreshMenuCount", "");
    } catch (e) {
      setAssignSaving(false);
    }
  };

  const renderLabel = (label: any, item: any) => (
    <div style={{
      padding: '6px 8px',
      lineHeight: 1.0
    }}>
      <div style={{
        fontWeight: 500,
        color: 'var(--semi-color-text-0)',
        fontSize: 14
      }}>
        {label}
        <span style={{
          fontSize: 12,
          color: 'var(--semi-color-text-2)',
          marginLeft: 10
        }}>
          {item.labelSubText}
        </span>
      </div>
    </div>
  );

  const openMortgageLoanModal = async (leadId: number, leadName: string) => {
    const w = window.open("about:blank");
    if (w != null) {
      const data = {
        id: leadId,
        name: leadName,
      };
      w.location.href =
        "/#/newleadLoan?data=" + encodeURIComponent(JSON.stringify(data));
    }
  };

  const rules = [{ required: true, message: "请填写" }];
  return !lead ? null : (
    <div>
      <Modal icon={<IconModalStroked size={"extra-large"} style={{ color: 'blue' }} />} title={"贷款信息：" + leadId}
        style={{ width: '1500px', height: '750px' }}
        headerStyle={{
          flexShrink: 0,
          borderBottom: '1px solid var(--semi-color-border)'
        }}
        bodyStyle={{
          overflow: 'auto',
          padding: '5px 5px',
          flex: 1
        }}
        footer={null}
        hasCancel={false} onCancel={() => setShowMortgageLoan(false)} onOk={() => setShowMortgageLoan(false)}
        visible={showMortgageLoan}>
        <div><IndexMortgageLoan leadId={leadId} /></div>
      </Modal>
      <Modal
        icon={<IconModalStroked size={"extra-large"} style={{ color: 'blue' }} />}
        title="新建提醒"
        visible={showTodo}
        onCancel={() => setShowTodo(false)}
        onOk={handleTodoSubmit}
        confirmLoading={savingTodo}
      >
        <Form getFormApi={(api) => setTodoFormApi(api)}>
          <Form.TextArea
            rules={rules}
            placeholder="提醒内容"
            rows={2}
            noLabel
            field="content"
          />
        </Form>
      </Modal>
      <Modal
        icon={<IconModalStroked size={"extra-large"} style={{ color: 'blue' }} />}
        style={{ width: 600, height: 600 }}
        title="分配客户"
        visible={showAssignModal}
        okText="分配"
        confirmLoading={assignSaving}
        onOk={handleAssignClick}
        onCancel={() => setShowAssignModal(false)}
      >
        <Form getFormApi={(formApi) => setAssignFormApi(formApi)}>
          <Form.TreeSelect
            placeholder="请选择分配给谁"
            rules={[{ required: true, message: "请填写" }]}
            style={{ width: "100%" }}
            field="assignToIds"
            label="销售"
            checkRelation="unRelated"
            leafOnly
            multiple
            treeData={teamMembersTree}
            initValue={selectedMembers}
            filterTreeNode
            showFilteredOnly={true}
            searchPlaceholder="请输入关键字开始搜索"
            renderLabel={renderLabel}
            autoAdjustOverflow={false}
            virtualize={{
              itemSize: 28,
              height: 400
            }}
          ></Form.TreeSelect>
          <Form.Select
            rules={[{ required: true, message: "请填写" }]}
            disabled
            initValue={selectedLeads.map((l) => l.id)}
            style={{ width: "100%" }}
            multiple
            field="leadIds"
            label="客户"
          >
            {selectedLeads.map((l) => (
              <Form.Select.Option key={l.id + ""} value={l.id}>
                {l.name}
              </Form.Select.Option>
            ))}
          </Form.Select>
        </Form>
      </Modal>
      <Modal
        className="lead-detail"
        footer={<div></div>}
        fullScreen
        visible={props.leadId != undefined}
        onOk={props.onOk}
        onCancel={props.onCancel}
        closeOnEsc={true}
      >
        <Form<Lead>
          getFormApi={(api) => setUserInfoForm(api)}
          labelAlign="right"
          labelWidth={100}
          labelPosition="left"
          initValues={lead}
          render={(form) => {
            const handleSubmit = async () => {
              setLeadSaving(true);

              const actVisitTimeNew:any = form.formApi.getValue("actVisitTimeNew");
              const estVisitTime:any = form.formApi.getValue("estVisitTime");
              const signedContractAt:any =
                form.formApi.getValue("signedContractAt");
              const paidReturnAt:any =
                form.formApi.getValue("paidReturnAt");
              try {
                form.formApi.validate();
                await apiClient.request("/leads", "PUT", undefined, {
                  ...form.formApi.getValues(),
                  actVisitTimeNew:
                    typeof actVisitTimeNew == "string"
                      ? actVisitTimeNew
                      : formatDateTime(actVisitTimeNew),
                  estVisitTime:
                    typeof estVisitTime == "string"
                      ? estVisitTime
                      : formatDateTime(estVisitTime),
                  signedContractAt:
                    typeof signedContractAt == "string"
                      ? signedContractAt
                      : formatDateTime(signedContractAt),
                  paidReturnAt:
                    typeof paidReturnAt == "string"
                      ? paidReturnAt
                      : formatDateTime(paidReturnAt),
                });
                setLeadSaving(false);
                Toast.info("客户信息已保存");
                form.formApi.setValue("content", "");
                refreshParentLead();
                loadLeadContactLogs();
                loadLeadStarLogs();
              } catch (e) {
                setLeadSaving(false);
              }
            };

            const starChangeEvent = (value: any) => {
              if (value == 0) {
                setStatusInfo(
                  statusInfoAll.filter((item) => {
                    return (
                      item.value == "PENDING_CONTACT" ||
                      item.value == "UNREACHABLE"
                    );
                  })
                );
                const currStatus:any = form.formApi.getValue("status");

                if (
                  currStatus != "PENDING_CONTACT" &&
                  currStatus != "UNREACHABLE"
                ) {
                  form.formApi.setValue("status", "PENDING_CONTACT");
                }
              } else if (value == 1) {
                setStatusInfo(
                  statusInfoAll.filter((item) => {
                    return (
                      item.value != "PENDING_CONTACT" &&
                      item.value != "UNREACHABLE"
                    );
                  })
                );
                const currStatus:any = form.formApi.getValue("status");

                if (
                  currStatus == "PENDING_CONTACT" ||
                  currStatus == "UNREACHABLE"
                ) {
                  form.formApi.setValue("status", "PENDING_VISIT");
                }
              } else {
                setStatusInfo(
                  statusInfoAll.filter((item) => {
                    return (
                      item.value != "PENDING_CONTACT" &&
                      item.value != "UNREACHABLE" &&
                      item.value != "OUT_LEAD" &&
                      item.value != "NON_COMPLIANCE"
                    );
                  })
                );
                const currStatus:any = form.formApi.getValue("status");
                if (
                  currStatus == "PENDING_CONTACT" ||
                  currStatus == "UNREACHABLE" ||
                  currStatus == "OUT_LEAD"
                ) {
                  form.formApi.setValue("status", "PENDING_VISIT");
                }
              }
            };

            const statusChangeEvent = (value: any) => {
              if (value == "OUT_LEAD") {
                setStarInfo(
                  starInfoAll.filter((item: any) => {
                    return item.value == 1;
                  })
                );
                form.formApi.setValue("star", 1);
                return;
              } else if (value == "VISITED") {
              } else if (value == "SIGNED_CONTRACT") {
                if (!lead.signedContractAt) {
                  form.formApi.setValue("signedContractAt", new Date());
                }
              } else if (value == "PAID") {
                if (!lead.paidReturnAt) {
                  form.formApi.setValue("paidReturnAt", new Date());
                }
              }
              setStarInfo(starInfoAll);
            };

            const handleFavClick = async () => {
              if (savingFav) {
                return;
              }
              Modal.confirm({
                title: "是否确认设置为重要客户?",
                content: "",
                onOk: async () => {
                  setSavingFav(true);
                  try {
                    await apiClient.request("/leads/fav", "POST", undefined, {
                      leadId: lead?.id,
                      fav: true,
                    });
                    Toast.info("已标记为重要客户");
                    setSavingFav(false);
                    setLeadFav(true);
                    pubsub.publish("refreshMenuCount", "");
                    localStorage.setItem("new-refresh", "true");
                    localStorage.setItem("my-refresh", "true");
                  } catch (e) {
                    setSavingFav(false);
                  }
                },
              });
            };

            const handleUnFavClick = async () => {
              if (savingFav) {
                return;
              }
              Modal.confirm({
                title: "是否确认设置为普通客户?",
                content: "",
                onOk: async () => {
                  setSavingFav(true);
                  try {
                    await apiClient.request("/leads/fav", "POST", undefined, {
                      leadId: lead?.id,
                      fav: false,
                    });
                    Toast.info("已取消标记为重要客户");
                    setSavingFav(false);
                    setLeadFav(false);
                    pubsub.publish("refreshMenuCount", "");
                    localStorage.setItem("fav-refresh", "true");
                  } catch (e) {
                    setSavingFav(false);
                  }
                },
              });
            };

            const handleMyToNewClick = async () => {
              if (savingFav) {
                return;
              }
              Modal.confirm({
                title: "是否确认设置为我的客户?",
                content: "",
                onOk: async () => {
                  setSavingFav(true);
                  try {
                    await apiClient.request(
                      "/leads/setMyToNew",
                      "POST",
                      undefined,
                      {
                        leadId: lead?.id,
                        fav: false,
                      }
                    );
                    Toast.info("已设置为我的客户");
                    setSavingFav(false);
                    setLeadMy(false);
                    pubsub.publish("refreshMenuCount", "");
                    localStorage.setItem("my-refresh", "true");
                    localStorage.setItem("new-refresh", "true");
                  } catch (e) {
                    setSavingFav(false);
                  }
                },
              });
            };

            const handleCallPhone = async () => {
              setContactLogSaving(true);
              try {
                await apiClient.request("/leadCallLog", "POST", undefined, {
                  leadId: leadId,
                });
                Toast.info("拨号成功");
                setContactLogSaving(false);
              } catch (e) {
                setContactLogSaving(false);
              }
            };

            return (
              <>
                <Row gutter={15} style={{padding:5}}>
                  <Col span={10}>
                    <Section text={"客户信息"}>
                      <Row gutter={10}>
                        <Col span={8}>
                          <Input readonly field="id" label="ID" />
                        </Col>
                        <Col span={8}>
                          <Input field="name" label="姓名" />
                        </Col>
                        <Col span={8}>
                          {renderDictRadio("gender", "gender", "性别")}
                        </Col>
                      </Row>
                      <Row gutter={10}>
                        <Col span={8}>
                          <InputNumber style={{ width: "100%" }} field="age" label="年龄" />
                        </Col>
                        <Col span={8}>
                          <InputNumber style={{ width: "100%" }} field="applyAmount" label="申请额度" />
                        </Col>
                        <Col span={8}>
                          <Form.Select field="applyCity" label="申请城市" style={{ width: "100%" }}
                             optionList={(dicts["city"] || []).map((o) => ({ value: o.value, label: o.label }))} />
                        </Col>
                      </Row>
                      {(role == "monitor" || role == "root" || role == "op_manager" || (city == "兰州" && (role == "quzhang" || role == "sale_manager" || role == "sale")) || city == "成都" || props.findLeadMode) && (
                        <Row gutter={10}>
                          <Col span={8}>
                            <Input readonly field="source" label="来源" />
                          </Col>
                          <Col span={16}>
                            {renderDictRadio("marriage", "marriage", "婚姻")}
                          </Col>
                        </Row>
                      )}
                      {!(role == "monitor" || role == "root" || role == "op_manager" || (city == "兰州" && (role == "quzhang" || role == "sale_manager" || role == "sale")) || city == "成都" || props.findLeadMode) && (
                        <Row gutter={10}>
                          <Col span={24}>
                            {renderDictRadio("marriage", "marriage", "婚姻")}
                          </Col>
                        </Row>
                      )}
                    </Section>

                    {/* ====== 资质信息卡片 ====== */}
                    <div style={{
                      background: 'var(--semi-color-bg-2)',
                      borderTop: '1px solid var(--semi-color-border)',
                      borderRadius: 12,
                      border: '1px solid var(--semi-color-border)'
                    }}>
                      <div style={{ display: "flex", width: "100%", marginTop:5, color: 'var(--semi-color-text-0)', justifyContent: "center" }}>
                        <Tooltip content="点击打开选项说明">
                          <Button onClick={openHelpPage} type="warning" theme="outline" icon={<IconHelpCircle />}>
                            资质帮助说明
                          </Button>
                        </Tooltip>
                      </div>

                      {(role == "monitor" || role == "root" || role == "op_manager" || (city == "兰州" && (role == "quzhang" || role == "sale_manager" || role == "sale")) || city == "成都" || props.findLeadMode) && (
                        <div style={{ borderBottom: '1px solid var(--semi-color-border)' }}>
                          {renderDictRadio("loanType", "loanType", "贷款类型")}
                        </div>
                      )}

                      <div style={{ borderBottom: '1px solid var(--semi-color-border)' }}>
                        {renderDictRadio("house", "house", "房产")}
                      </div>

                      <div style={{ borderBottom: '1px solid var(--semi-color-border)' }}>
                        {renderDictRadio("vehicle", "vehicle", "车产")}
                      </div>

                      <div style={{ padding: '2px 0', borderBottom: '1px solid var(--semi-color-border)' }}>
                        {renderDictRadio("company", "company", "公司")}
                      </div>

                      <div style={{ padding: '2px 0', borderBottom: '1px solid var(--semi-color-border)' }}>
                        {renderDictRadio("providentFund", "providentFund", "公积金")}
                      </div>

                      <div style={{ padding: '2px 0', borderBottom: '1px solid var(--semi-color-border)' }}>
                        {renderDictRadio("workYears", "workYears", "工作年限")}
                      </div>

                      <div style={{ padding: '2px 0', borderBottom: '1px solid var(--semi-color-border)' }}>
                        {renderDictRadio("income", "income", "收入")}
                      </div>

                      <Row>
                        <Col span={24}>
                          <TextArea autosize field="remark" label="资质描述" />
                        </Col>
                      </Row>
                    </div>

                    <div>
                      {/* 公司名称 + 白名单 */}
                      <div style={{ padding: '2px 0', borderBottom: '1px solid var(--semi-color-border)', display: 'flex', gap: 5 }}>
                        <div style={{ flex: 1 }}>
                          <Input field="companyName" label="公司名称" />
                        </div>
                        <div style={{ flex: 1 }}>
                          <Input field="whiteBankName" label="白名单" readonly />
                        </div>
                      </div>

                      {/* 代发银行 + 代发工资 + 公积金基数 */}
                      <div style={{ padding: '2px 0', borderBottom: '1px solid var(--semi-color-border)', display: 'flex', gap: 5 }}>
                        <div style={{ flex: 1 }}>
                          <Input field="salaryBankName" label="代发银行" />
                        </div>
                        <div style={{ flex: 1 }}>
                          <Input field="salary" label="代发工资" />
                        </div>
                        <div style={{ flex: 1 }}>
                          <Input field="providentFundBasic" label="公积金基数" />
                        </div>
                      </div>

                      {/* 释放日期 + 签约点位 + 学历 */}
                      <div style={{ padding: '2px 0', borderBottom: '1px solid var(--semi-color-border)', display: 'flex', gap: 5 }}>
                        <div style={{ flex: 1 }}>
                          <DatePicker type="date" style={{ width: '100%' }} field="settledLoanAt" label="释放日期" disabled />
                        </div>
                        <div style={{ flex: 1 }}>
                          <Input field="loanPoint" label="签约点位" />
                        </div>
                        <div style={{ flex: 1 }}>
                          <Input field="education" label="学历" />
                        </div>
                      </div>
                    </div>
                  </Col>

                  <Col span={9}>
                    <Section text={"客户跟进"}>
                      {/* ====== 顶部客户概览卡片 ====== */}
                      <div style={{
                        display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px',
                        background: 'linear-gradient(135deg, var(--semi-color-primary-light) 0%, var(--semi-color-bg-2) 100%)',
                        borderRadius: 12, marginBottom: 12,
                        border: '1px solid var(--semi-color-border)',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                      }}>
                        <div style={{ flex: 1 }}>
                          {showMobile && lead && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                              <span style={{ fontSize: 18, fontWeight: 700, color: 'var(--semi-color-text-0)' }}>
                                {lead.name}
                              </span>
                              <span style={{ fontSize: 15, color: 'var(--semi-color-text-1)' }}>
                                {lead.fullMobile}
                              </span>
                            </div>
                          )}
                          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            {lead?.userAgreement && (
                              <a href={lead.userAgreement} target="_blank" rel="noopener noreferrer"
                                 style={{ fontSize: 12, color: 'var(--semi-color-primary)', textDecoration: 'none' }}>
                                用户授权协议
                              </a>
                            )}
                            {(() => {
                              const lsMap: Record<string, { color: "grey" | "blue" | "red" | "green"; text: string }> = {
                                NOT_LOAN: { color: "grey", text: '未贷款' },
                                LOANING: { color: "blue", text: '还款中' },
                                BAD_DEPT: { color: "red", text: '已坏账' },
                                SETTLED: { color: "green", text: '已释放' },
                              };
                              const ls = lsMap[lead?.loanStatus || ''] || { color: "grey" as const, text: lead?.loanStatus || '' };
                              return <Tag color={ls.color} size="large" shape="circle">{ls.text}</Tag>;
                            })()}
                            {(lead?.loanStatus && lead?.loanStatus !== 'NOT_LOAN') && (
                              <Button size="small" theme="light" onClick={() => openMortgageLoanModal(lead?.id, lead?.name)}>贷款信息</Button>
                            )}
                          </div>
                        </div>
                        {showMobile && (
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <Button onClick={handleCallPhone} icon={<IconUserCardPhone />} type="danger" theme="solid" size="large">
                              拨号
                            </Button>
                            <Tooltip style={{ maxWidth: 400 }} content={callPhoneHelp}>
                              <IconHelpCircle style={{ color: "#E91E63", fontSize: 18, cursor: 'pointer' }} />
                            </Tooltip>
                          </div>
                        )}
                      </div>

                      {/* ====== 星级状态卡片 ====== */}
                      <div style={{
                        background: 'var(--semi-color-bg-2)',
                        borderRadius: 12,
                        padding: '12px 16px',
                        marginBottom: 12,
                        border: '1px solid var(--semi-color-border)'
                      }}>
                        <div style={{
                          fontSize: 13,
                          fontWeight: 600,
                          color: 'var(--semi-color-text-0)',
                          marginBottom: 12,
                          display: 'flex',
                          alignItems: 'center',
                          gap: 6
                        }}>
                          <span>⭐</span> 星级与状态
                        </div>
                        <Row gutter={12}>
                          <Col span={12}>
                            <Form.Select
                              field="star"
                              label={{
                                text: "星级",
                                extra: (
                                  <Tooltip style={{ maxWidth: 400 }} content={starHelp}>
                                    <IconHelpCircle style={{ color: "#E91E63" }} />
                                  </Tooltip>
                                ),
                              }}
                              onChange={starChangeEvent}
                            >
                              {starInfo.map((pro) => (
                                <Select.Option value={pro.value} key={pro.value}>
                                  {pro.label}
                                </Select.Option>
                              ))}
                            </Form.Select>
                          </Col>
                          <Col span={12}>
                            <Form.Select
                              field="status"
                              label="状态"
                              onChange={statusChangeEvent}
                            >
                              {statusInfo.map((pro) => (
                                <Select.Option
                                  value={pro.value}
                                  key={pro.value}
                                  disabled={readOnlyLeadStatus.includes(displayLeadStatus(pro.value))}
                                >
                                  {pro.label}
                                </Select.Option>
                              ))}
                            </Form.Select>
                          </Col>
                        </Row>
                      </div>

                      {/* ====== 时间节点卡片 ====== */}
                      <div style={{
                        background: 'var(--semi-color-bg-2)',
                        borderRadius: 12,
                        padding: '12px 16px',
                        marginBottom: 12,
                        border: '1px solid var(--semi-color-border)'
                      }}>
                        <div style={{
                          fontSize: 13,
                          fontWeight: 600,
                          color: 'var(--semi-color-text-0)',
                          marginBottom: 12,
                          display: 'flex',
                          alignItems: 'center',
                          gap: 6
                        }}>
                          <span>📅</span> 时间节点
                        </div>
                        <Row gutter={12}>
                          <Col span={12}>
                            <Form.DatePicker type="dateTime" style={{ width: "100%" }} field="estVisitTime" label="预计上门" />
                          </Col>
                          <Col span={12}>
                            <Form.DatePicker
                              type="dateTime"
                              style={{ width: "100%" }}
                              field="actVisitTimeNew"
                              disabled={actVisitTimeDisabled}
                              label={{
                                text: "实际上门",
                                extra: (
                                  <Tooltip style={{ maxWidth: 400, wordBreak: "break-all", whiteSpace: "pre-wrap" }} content={visitSignLogText}>
                                    <IconHelpCircle style={{ color: "#E91E63" }} />
                                  </Tooltip>
                                ),
                              }}
                            />
                          </Col>
                          <Col span={12}>
                            <Form.DatePicker type="dateTime" style={{ width: "100%" }} field="signedContractAt" label="签约时间" />
                          </Col>
                          <Col span={12}>
                            <Form.DatePicker type="dateTime" style={{ width: "100%" }} field="paidReturnAt" label="回款时间" />
                          </Col>
                        </Row>
                      </div>

                      {/* ====== 跟进记录输入卡片 ====== */}
                      <div style={{
                        background: 'var(--semi-color-bg-2)',
                        borderRadius: 12,
                        padding: '12px 16px',
                        marginBottom: 12,
                        border: '1px solid var(--semi-color-border)'
                      }}>
                        <div style={{
                          fontSize: 13,
                          fontWeight: 600,
                          color: 'var(--semi-color-text-0)',
                          marginBottom: 12,
                          display: 'flex',
                          alignItems: 'center',
                          gap: 6
                        }}>
                          <span>📝</span> 跟进记录
                        </div>
                        <Row>
                          <Col span={24}>
                            <Form.TextArea
                              autoFocus
                              style={{ width: "100%" }}
                              field="content"
                              noLabel
                              placeholder="请输入跟进内容..."
                              rows={3}
                            />
                            <Form.Slot noLabel>
                              <div style={{ marginTop: 8 }}>
                                <div style={{
                                  fontSize: 12,
                                  color: 'var(--semi-color-text-2)',
                                  marginBottom: 6
                                }}>
                                  快捷模板：
                                </div>
                                <Space wrap style={{ gap: 6 }}>
                                  {contactLogTemplate.map((t: any) => (
                                    <Button
                                      size="small"
                                      theme="light"
                                      key={t}
                                      onClick={() => form.formApi.setValue("content", t)}
                                      style={{
                                        borderRadius: 16,
                                        fontSize: 12,
                                        padding: '0 12px',
                                        height: 28,
                                        background: 'var(--semi-color-fill-0)'
                                      }}
                                    >
                                      {t}
                                    </Button>
                                  ))}
                                </Space>
                              </div>
                            </Form.Slot>
                          </Col>
                        </Row>
                      </div>

                      {/* 操作工具栏 */}
                      {(!props.viewMode || props.visitMode) && (
                        <div style={{
                          background: 'var(--semi-color-bg-2)',
                          borderRadius: 12,
                          padding: '12px 16px',
                          marginBottom: 12,
                          border: '1px solid var(--semi-color-border)'
                        }}>
                          <Space wrap style={{ gap: 8 }}>
                            <Button size="large" icon={<IconSave />} theme="solid" type="primary" onClick={handleSubmit} loading={leadSaving || loadingAll}>
                              保存
                            </Button>
                            <Button icon={<IconBell />} type="secondary" onClick={() => setShowTodo(true)}>提醒</Button>
                            <Button icon={<IconRotate />} type="danger" theme="light" onClick={handleSendToPool}>公共池</Button>
                            {!leadFav ? (
                              <Button icon={<IconLikeHeart />} type="secondary" onClick={handleFavClick}>重要</Button>
                            ) : (
                              <Button icon={<IconLikeHeart />} type="warning" onClick={handleUnFavClick}>取消重要</Button>
                            )}
                            {leadMy && (
                              <Button icon={<IconCopy />} type="secondary" onClick={handleMyToNewClick}>我的客户</Button>
                            )}
                            {hasAssignPriv && (
                              <Button icon={<IconBookmark />} type="secondary" onClick={handleAssignButtonClick}>分配</Button>
                            )}
                          </Space>
                        </div>
                      )}

                      {props.leadFrom != "reportShow" && (
                        <div style={{
                          background: 'var(--semi-color-bg-2)',
                          borderRadius: 12,
                          padding: '12px 16px',
                          border: '1px solid var(--semi-color-border)'
                        }}>
                          <Space style={{ gap: 8 }}>
                            <Button icon={<IconChevronLeft />} loading={loadingAll} onClick={handlePrevClick}>上一条</Button>
                            <Button icon={<IconChevronRight />} iconPosition="right" loading={loadingAll} onClick={handleNextClick}>下一条</Button>
                          </Space>
                        </div>
                      )}
                    </Section>
                  </Col>

                  <Col span={5}>
                    <Tabs type="line" defaultActiveKey="contactLogs">
                      <TabPane tab="跟进记录" itemKey="contactLogs">
                        <div style={{ padding: '2px 0' }}>
                          {leadContactLogs.length === 0 ? (
                            <div style={{
                              textAlign: 'center',
                              padding: '40px 0',
                              color: 'var(--semi-color-text-2)'
                            }}>
                              暂无跟进记录
                            </div>
                          ) : (
                            <List<LeadContactLog>
                              dataSource={leadContactLogs}
                              style={{ overflowY: "auto", maxHeight: 'calc(100vh - 260px)' }}
                              renderItem={(l, index: number) => (
                                <div style={{
                                  position: 'relative',
                                  paddingLeft: 24,
                                  paddingBottom: index < leadContactLogs.length - 1 ? 20 : 0,
                                  borderLeft: index < leadContactLogs.length - 1 ? '2px solid var(--semi-color-border)' : 'none',
                                  marginLeft: 12
                                }}>
                                  <div style={{
                                    position: 'absolute',
                                    left: -6,
                                    top: 4,
                                    width: 10,
                                    height: 10,
                                    borderRadius: '50%',
                                    background: 'var(--semi-color-success)',
                                    border: '2px solid var(--semi-color-bg-0)'
                                  }} />
                                  <div style={{
                                    background: 'var(--semi-color-fill-0)',
                                    borderRadius: 8,
                                    padding: '12px 16px',
                                    marginBottom: 8
                                  }}>
                                    <div style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      marginBottom: 8
                                    }}>
                                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <span style={{
                                          fontWeight: 600,
                                          fontSize: 14,
                                          color: 'var(--semi-color-success)'
                                        }}>
                                          {l.saleName}
                                        </span>
                                        <Tag size="small" color="green">跟进</Tag>
                                      </div>
                                      <span style={{
                                        fontSize: 12,
                                        color: 'var(--semi-color-text-2)'
                                      }}>
                                        {formatRelativeTime(l.createdAt)}
                                      </span>
                                    </div>
                                    <div style={{
                                      padding: '10px 12px',
                                      background: 'var(--semi-color-bg-0)',
                                      borderRadius: 6,
                                      fontSize: 13,
                                      color: 'var(--semi-color-text-0)',
                                      lineHeight: 1.6,
                                      whiteSpace: 'pre-wrap'
                                    }}>
                                      {l.content}
                                    </div>
                                  </div>
                                </div>
                              )}
                            />
                          )}
                        </div>
                      </TabPane>
                      <TabPane tab="分配记录" itemKey="assignLogs">
                        <div style={{ padding: '2px 0' }}>
                          {leadAssignLogs.length === 0 ? (
                            <div style={{
                              textAlign: 'center',
                              padding: '40px 0',
                              color: 'var(--semi-color-text-2)'
                            }}>
                              暂无分配记录
                            </div>
                          ) : (
                            <List<LeadAssignLog>
                              dataSource={leadAssignLogs}
                              style={{ overflowY: "auto", maxHeight: 'calc(100vh - 260px)' }}
                              renderItem={(l: LeadAssignLog, index: number) => (
                                <div style={{
                                  position: 'relative',
                                  paddingLeft: 24,
                                  paddingBottom: index < leadAssignLogs.length - 1 ? 20 : 0,
                                  borderLeft: index < leadAssignLogs.length - 1 ? '2px solid var(--semi-color-border)' : 'none',
                                  marginLeft: 12
                                }}>
                                  <div style={{
                                    position: 'absolute',
                                    left: -6,
                                    top: 4,
                                    width: 10,
                                    height: 10,
                                    borderRadius: '50%',
                                    background: 'var(--semi-color-primary)',
                                    border: '2px solid var(--semi-color-bg-0)'
                                  }} />
                                  <div style={{
                                    background: 'var(--semi-color-fill-0)',
                                    borderRadius: 8,
                                    padding: '12px 16px',
                                    marginBottom: 8
                                  }}>
                                    <div style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 2,
                                      marginBottom: 8
                                    }}>
                                      <div style={{
                                        padding: '1px 1px',
                                        background: 'var(--semi-color-warning-light)',
                                        borderRadius: 6,
                                        fontSize: 13,
                                        fontWeight: 500,
                                        color: 'var(--semi-color-text-0)'
                                      }}>
                                        {l.assignBy}
                                      </div>
                                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
                                        <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="var(--semi-color-primary)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                      </svg>
                                      <div style={{
                                        padding: '1px 1px',
                                        background: 'var(--semi-color-primary-light)',
                                        borderRadius: 6,
                                        fontSize: 13,
                                        fontWeight: 600,
                                        color: 'var(--semi-color-text-0)'
                                      }}>
                                        {l.saleName}
                                      </div>
                                      <span style={{
                                        fontSize: 12,
                                        color: 'var(--semi-color-text-2)',
                                        marginLeft: 'auto'
                                      }}>
                                        {formatRelativeTime(l.createdAt)}
                                      </span>
                                    </div>
                                    {l.remark && (
                                      <div style={{
                                        padding: '8px 12px',
                                        background: 'var(--semi-color-bg-0)',
                                        borderRadius: 6,
                                        fontSize: 13,
                                        color: 'var(--semi-color-text-0)',
                                        lineHeight: 1.6
                                      }}>
                                        {l.remark}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                            />
                          )}
                        </div>
                      </TabPane>
                      <TabPane tab="星级状态" itemKey="starLogs">
                        <div style={{ padding: '2px 0' }}>
                          {leadStarLogs.length === 0 ? (
                            <div style={{
                              textAlign: 'center',
                              padding: '40px 0',
                              color: 'var(--semi-color-text-2)'
                            }}>
                              暂无星级状态记录
                            </div>
                          ) : (
                            <List<LeadStarLog>
                              dataSource={leadStarLogs}
                              style={{ overflowY: "auto", maxHeight: 'calc(100vh - 260px)' }}
                              renderItem={(l, index: number) => (
                                <div style={{
                                  position: 'relative',
                                  paddingLeft: 24,
                                  paddingBottom: index < leadStarLogs.length - 1 ? 20 : 0,
                                  borderLeft: index < leadStarLogs.length - 1 ? '2px solid var(--semi-color-border)' : 'none',
                                  marginLeft: 12
                                }}>
                                  <div style={{
                                    position: 'absolute',
                                    left: -6,
                                    top: 4,
                                    width: 10,
                                    height: 10,
                                    borderRadius: '50%',
                                    background: 'var(--semi-color-primary)',
                                    border: '2px solid var(--semi-color-bg-0)'
                                  }} />
                                  <div style={{
                                    background: 'var(--semi-color-fill-0)',
                                    borderRadius: 8,
                                    padding: '12px 16px',
                                    marginBottom: 8
                                  }}>
                                    <div style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      marginBottom: 8
                                    }}>
                                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <span style={{
                                          fontWeight: 600,
                                          fontSize: 14,
                                          color: 'var(--semi-color-text-0)'
                                        }}>
                                          {l.saleName}
                                        </span>
                                        <Tag size="small" color="blue">状态变更</Tag>
                                      </div>
                                      <span style={{
                                        fontSize: 12,
                                        color: 'var(--semi-color-text-2)'
                                      }}>
                                        {formatRelativeTime(l.createdAt)}
                                      </span>
                                    </div>
                                    <div style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 12,
                                      padding: '8px 12px',
                                      background: 'var(--semi-color-bg-0)',
                                      borderRadius: 6,
                                      marginBottom: 8
                                    }}>
                                      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                        <span style={{ fontSize: 13, color: 'var(--semi-color-text-2)' }}>星级：</span>
                                        <span style={{
                                          fontWeight: 600,
                                          fontSize: 14,
                                          color: 'var(--semi-color-warning)'
                                        }}>
                                          {displayStar(l.star)}
                                        </span>
                                      </div>
                                      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                        <span style={{ fontSize: 13, color: 'var(--semi-color-text-2)' }}>状态：</span>
                                        <Tag size="small">{displayLeadStatus(l.status)}</Tag>
                                      </div>
                                    </div>
                                    {l.remark && (
                                      <div style={{
                                        padding: '8px 12px',
                                        background: 'var(--semi-color-warning-light)',
                                        borderRadius: 6,
                                        fontSize: 13,
                                        color: 'var(--semi-color-text-0)',
                                        lineHeight: 1.6
                                      }}>
                                        {l.remark}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                            />
                          )}
                        </div>
                      </TabPane>
                      <TabPane tab="按揭记录" itemKey="loanContactLogs">
                        <List<LoanContactLog>
                          dataSource={loanContactLogs}
                          style={{ overflowY: "auto", maxHeight: 'calc(100vh - 260px)' }}
                          renderItem={(l) => (
                            <List.Item
                              style={l.todoType == "QUESTION" ? { color: "#303133" } : { color: "#409EFF" }}
                              header={
                                <Avatar color={l.todoType == "QUESTION" ? "green" : "blue"}>
                                  <span style={{ fontSize: 14, padding: 4 }}>
                                    {avatarName(l.createdByName)}
                                  </span>
                                </Avatar>
                              }
                              main={
                                <div>
                                  <span style={{ color: 'var(--semi-color-text-0)', fontWeight: 500 }}>
                                    {formatRelativeTime(l.createdAt)}
                                  </span>
                                  <p style={{ color: 'var(--semi-color-text-2)', margin: '4px 0' }}>
                                    @{l.userName}：{l.content}
                                  </p>
                                </div>
                              }
                            />
                          )}
                        />
                      </TabPane>
                    </Tabs>
                  </Col>
                </Row>
              </>
            );
          }}
        ></Form>
      </Modal>

      <SideSheet title="客户资质说明" visible={helpVisible} onCancel={() => setHelpVisible(!helpVisible)} placement="right" size="large">
        <iframe src={`/mis/dict-help.html?category=${activeHelpCategory}`} style={{ width: '100%', height: '99%', border: 'none' }} />
      </SideSheet>
    </div>
  );
}
